import { useEffect } from 'react';
import { RestrictionParameters, useRepositoryQuery } from '@mews-commander/data-access';
import { updateRestrictionsState } from '@mews-commander/legacy-entities/src/ducks';
import { useCommanderThunkDispatch } from '@mews-commander/utils';
import { FormType } from '../components/form/types';
import { initRestrictionForm } from '../actions';

interface RestrictionQuery extends RestrictionParameters {
    restrictionId: string | null;
    formType: FormType;
}
export const useRestrictions = ({ restrictionId, formType, ...other }: RestrictionQuery) => {
    const dispatch = useCommanderThunkDispatch();

    const query = useRepositoryQuery('restrictions', 'getAll', {
        ...other,
        restrictionIds: restrictionId ? [restrictionId] : [],
    });

    useEffect(() => {
        if (!query.data) return;

        if (query.data.restrictions) {
            dispatch(updateRestrictionsState(query.data.restrictions, other.serviceId));
        }
        dispatch(initRestrictionForm(restrictionId, other.serviceId, formType));
    }, [dispatch, formType, other.serviceId, query.data, restrictionId]);

    return query;
};
